export default {
  root: {
    // The default padding is 8 which does not line up with the padding
    // from the content.  I guess that's by design but I think it looks ugly.
    padding: 16,
  },
};
